import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useContent } from 'views/rebranded-module/common/context/useContent';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(duration);

interface FlashSaleProps {
  flashSaleEnabled: boolean;
  flashSaleEndTime: string;
}

interface TimeLeftItem {
  text: string;
  num: number;
}

type UseFlashSaleReturn = [boolean, TimeLeftItem[]];

export const useFlashSale = (props:FlashSaleProps): UseFlashSaleReturn => {
  const { flashSaleEnabled, flashSaleEndTime } = props;
  const content = useContent('DealDetailsPage');
  const [timeLeft, setTimeLeft] = useState<TimeLeftItem[]>([]);
  const [enableSale, setEnableSale] = useState<boolean>(flashSaleEnabled);

  const calculateTimeLeft = () => {
    const now = dayjs().tz('America/Los_Angeles');
    const endDateTime = dayjs(flashSaleEndTime).tz('America/Los_Angeles');
    const difference = endDateTime.diff(now);

    if (difference > 0) {
      const diffDuration = dayjs.duration(difference);
      setTimeLeft([
        { text: content.daysLabel, num: diffDuration.days() },
        { text: content.hoursLabel, num: diffDuration.hours() },
        { text: content.minutesLabel, num: diffDuration.minutes() },
        { text: content.secondsLabel, num: diffDuration.seconds() },
      ]);
      setEnableSale(true);
    } else {
      setEnableSale(false);
    }
  };
// eslint-disable-next-line consistent-return
  useEffect(() => {
    if (enableSale) {
      const interval = setInterval(calculateTimeLeft, 1000);
      return () => clearInterval(interval);
    }
  }, [enableSale, flashSaleEndTime]);

  return [enableSale, timeLeft];
};
export default useFlashSale;